import _ from "lodash";
/**--external-- */
import React from "react";
import update from "immutability-helper";

/**-internal-- */
import EmptyField from "UIComponents/EmptyField";

/**--relative-- */
import Field from "../Field";
import { getCardPlannerElementSetProperties } from "./FieldCardsV2Utils";
import Cards from "./components/Cards";
import classes from "./FieldCardsV2.scss";
import classNames from "classnames";

class FieldCardsV2 extends Field {
  constructor(props) {
    super(props);
  }

  renderPreviewContent = () => {
    const { plannerElementSetConfig, options } = this.props;

    const updatedOptions = _.map(options, node => ({
      ...node,
      value: node.id,
    }));

    const {
      allowDescription,
      allowIcon,
      selectionType = "SINGLE_SELECT",
    } = getCardPlannerElementSetProperties({ plannerElementSetConfig });

    return (
      <Cards
        showSubtext={allowDescription}
        showIcon={allowIcon}
        isSingleSelect={selectionType === "SINGLE_SELECT"}
        options={updatedOptions}
      />
    );
  };

  renderView = () => {
    const { fieldObj, customTextStyle } = this.props;
    const resolvedValue = _.get(fieldObj, "resolvedMinimalTree.nodes", []);
    const value = _.join(
      _.map(resolvedValue, node => _.get(node, "label", "")),
      ", "
    );
    const viewModeClasses = classNames({
      [classes.viewModeContainer]: true,
      "text-body-1": true,
    });
    return _.isEmpty(value) ? (
      this.renderViewEmpty()
    ) : (
      <div className={viewModeClasses} style={customTextStyle}>
        {value}
      </div>
    );
  };

  onClickCard = ({ id, operation }) => {
    const {
      plannerElementSet: { nodes, config: plannerElementSetConfig },
      value,
    } = this.props;

    const {
      selectionType = "SINGLE_SELECT",
    } = getCardPlannerElementSetProperties({ plannerElementSetConfig });

    let selectedCards = value ? value : [];

    switch (operation) {
      case "add":
        if (selectionType === "MULTI_SELECT") {
          selectedCards = update(selectedCards, {
            $push: [id],
          });
        } else {
          selectedCards = [id];
        }
        break;

      case "remove": {
        const index = _.indexOf(selectedCards, id);
        selectedCards = update(selectedCards, {
          $splice: [[index, 1]],
        });
        break;
      }
    }

    this.updateValue(selectedCards, { nodes });
  };

  renderEdit = () => {
    const { plannerElementSet = {}, value, emptyText } = this.props;
    const { config: plannerElementSetConfig, nodes } = plannerElementSet;
    const {
      allowDescription,
      allowIcon,
      selectionType,
    } = getCardPlannerElementSetProperties({ plannerElementSetConfig });

    if (_.isEmpty(nodes)) {
      return <EmptyField title={emptyText} />;
    }
    return (
      <Cards
        showSubtext={allowDescription}
        showIcon={allowIcon}
        isSingleSelect={selectionType === "SINGLE_SELECT"}
        options={nodes}
        value={value}
        onClickCard={this.onClickCard}
      />
    );
  };
}

export default FieldCardsV2;

FieldCardsV2.defaultProps = {
  ...Field.defaultProps,
  options: [],
  plannerElementSetConfig: {},
};

FieldCardsV2.displayName = "FieldCardsV2";
